import './formDetalle.scss';
import { useState, useEffect, useContext } from "react";
import { OfertasDetFormContext } from '../../../../../context/ofertasdet/OfertasDetContext';
import ArticulosModal from '../../../../articulos/articulosModal/articulosModal';
import { getOfertaDetPanel } from '../../../../../services/OfertasDetServices';
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";

export const FormDetalle = ({
  aofid,
  iddet,
  tipooferta,
  tipoprecio,
  addItem,
  getItem,
  updateItem,
  arrayDetalle,
  ultimoID,
  closeModal
}) => {

  const {
    report,
    getOfertaDetByIdData,
    patchOfertaDetData,
    getArticuloByIdData,
  } = useContext(OfertasDetFormContext);

  const [title, setTitle] = useState('');
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [selectedRow, setSelectedRow] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [estadoForm, setEstadoForm] = useState('');

  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    iddet ? setTitle('Editar Artículo de Oferta') : setTitle('Agregar Artículo a Oferta');
  }, [iddet]);

  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.id === iddet);

        if (detalleEnArray) {
          setForm((prevForm) => ({
            ...prevForm,
            art_descripcion: detalleEnArray?.oferta_Art?.art_descripcion || prevForm.art_descripcion || "",
            ...detalleEnArray,
          }));
          setEstadoForm(1);
        } else {
          try {
            const detalle = await getOfertaDetByIdData(iddet); 
            if (detalle) {
              const articulo = await getArticuloByIdData(detalle.art_Id);
              setForm(prevForm => ({
                ...prevForm,
                ...detalle,
                art_descripcion: articulo?.art_descripcion || '',
                art_codigo: articulo?.art_codigo || '',
              }));
              setEstadoForm(1);
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
    };

    fetchData();
  }, [aofid, iddet]);

  const handleSelectArticulo = (art_id, art_codigo, art_descripcion, art_npreciocosto, preciobuscado) => {
    const precioBase = Number(preciobuscado);
    const costo = Number(art_npreciocosto);
    const margenActual = costo > 0 ? ((precioBase - costo) / costo) * 100 : 0;

    setForm((prevForm) => ({
      ...prevForm,
      art_Id: art_id,
      art_codigo: art_codigo,
      art_descripcion: art_descripcion,
      aofd_ofertacosto: costo.toFixed(2),
      aofd_art_nprecio: precioBase.toFixed(2),
      aofd_margenactual: margenActual.toFixed(2),
      aofd_ofertadescto: 0,
      aofd_ofertaprecio: precioBase.toFixed(2),
      aofd_margen: margenActual.toFixed(2),
      aofd_ofertastock: '',
      aofd_show_web: 0,
      aofd_show_app: 0,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prevForm) => {
      let updatedForm = { ...prevForm };
      updatedForm[name] = value;

      const precioBase = Number(updatedForm.aofd_art_nprecio) || 0;
      const costo = Number(updatedForm.aofd_ofertacosto) || 0;

      // Si cambia PRECIO DE OFERTA → calcula DESCUENTO y MARGEN
      if (name === "aofd_ofertaprecio") {
        const precioOferta = Number(value) || 0;
        const descuento = precioBase > 0 ? ((1 - (precioOferta / precioBase)) * 100) : 0;
        const margen = costo > 0 ? ((precioOferta - costo) / costo * 100) : 0;

        updatedForm.aofd_ofertadescto = descuento.toFixed(2);
        updatedForm.aofd_margen = margen.toFixed(2);
      }

      // Si cambia DESCUENTO → calcula PRECIO y MARGEN
      if (name === "aofd_ofertadescto") {
        const descuento = Number(value) || 0;
        const precioOferta = precioBase * ((100 - descuento) / 100);
        const margen = costo > 0 ? ((precioOferta - costo) / costo * 100) : 0;

        updatedForm.aofd_ofertaprecio = precioOferta.toFixed(2);
        updatedForm.aofd_margen = margen.toFixed(2);
      }

      return updatedForm;
    });
  };

  const validateForm = async () => {
    let formErrors = {};

    if (!form.art_codigo || form.art_codigo.trim() === '') {
      formErrors.art_codigo = 'El Código es obligatorio';
    }

    if (Number(tipooferta) === 1) {
      if (!form.aofd_ofertastock || String(form.aofd_ofertastock).trim() === '') {
        formErrors.aofd_ofertastock = 'El Stock de oferta es obligatorio';
      } else if (Number(form.aofd_ofertastock) === 0) {
        formErrors.aofd_ofertastock = 'El Stock no puede ser 0';
      }
    }

    if (!form.aofd_ofertaprecio || Number(form.aofd_ofertaprecio) <= 0) {
      formErrors.aofd_ofertaprecio = 'El precio de oferta es obligatorio';
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    if (!iddet) {
      const existente = await buscarExistente();
      if (existente) {
        formErrors.art_codigo = 'El artículo ya existe en esta oferta';
        setErrors(formErrors);
        return false;
      }
    }

    setErrors({});
    return true;
  };

  const buscarExistente = async () => {
    const encontradoArray = arrayDetalle.find(item => item.art_Id === form.art_Id);

    if (Number(aofid)) {
      try {
        const encontradoData = await getOfertaDetPanel(aofid, form.art_Id);
        if (encontradoData?.pagination?.totalItems > 0) {
          return encontradoData;
        }
      } catch (error) {
        return null;
      }
    }

    return encontradoArray || null;
  };

  const handleSendData = async () => {
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }

    setIsSubmitting(true);
    try {
      const generateRandomId = () => `temp-${Math.floor(Math.random() * 1000000)}-${Date.now()}`;

      const oferta_Art = {
        id: form.art_Id,
        art_descripcion: form.art_descripcion,
        art_codigo: form.art_codigo,
      };

      const newForm = {
        art_Id: form.art_Id,
        ofcab_id: Number(aofid) || null,
        aofd_ofertacosto: Number(form.aofd_ofertacosto) || 0,
        aofd_art_nprecio: Number(form.aofd_art_nprecio) || 0,
        aofd_ofertaprecio: Number(form.aofd_ofertaprecio) || 0,
        aofd_ofertadescto: Number(form.aofd_ofertadescto) || 0,
        aofd_margen: Number(form.aofd_margen) || 0,
        aofd_margenactual: Number(form.aofd_margenactual) || 0,
        aofd_ofertastock: Number(form.aofd_ofertastock) || 0,
        aofd_show_web: form.aofd_show_web || 0,
        aofd_show_app: form.aofd_show_app || 0,
        oferta_Art: oferta_Art,
        id: iddet || generateRandomId(),
      };

      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.id === iddet);
        if (detalleEnArray) {
          await updateItem(detalleEnArray.id, newForm);
        } else {
          await patchOfertaDetData(iddet, newForm);
        }
      } else {
        await addItem(newForm);
      }

      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
      openErrorDialog("Error al guardar. Intente nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const resetForm = () => {
    setForm({});
  };

  const handleCancel = () => {
    setSelectedRow('');
    setEstadoForm(0);
    resetForm();
    closeModal();
  };

  return (
    <>
      <div className="formDetalle">
        <div className="formDetalle__header">
          <h3>{title}</h3>
        </div>

        <div className="formDetalle__body">
          {/* SECCIÓN: ARTÍCULO */}
          <div className="formDetalle__section">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">📦</span>
              Artículo
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--3cols">
              
              {estadoForm !== 1 && (
                <div className="formDetalle__field formDetalle__field--search">
                  <label>Buscar Artículo</label>
                  <ArticulosModal
                    handleChange={setSearchIdArt}
                    handleDescChange={setSearchDescArt}
                    descSelected={searchIdArt}
                    onSelect={handleSelectArticulo}
                    tipoprecio={tipoprecio}
                  />
                </div>
              )}

              <div className="formDetalle__field">
                <label>Código</label>
                <input
                  type="text"
                  value={form.art_codigo ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
                {errors.art_codigo && <span className="formDetalle__error">{errors.art_codigo}</span>}
              </div>

              <div className="formDetalle__field formDetalle__field--wide">
                <label>Descripción</label>
                <input
                  type="text"
                  value={form.art_descripcion ?? ''}
                  className="formDetalle__input formDetalle__input--readonly"
                  readOnly
                />
              </div>
            </div>
          </div>

          {/* SECCIÓN: PRECIOS ACTUALES */}
          <div className="formDetalle__section formDetalle__section--info">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">💰</span>
              Precios Actuales
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--3cols">
              
              <div className="formDetalle__field">
                <label>Costo + Flete</label>
                <div className="formDetalle__input-group">
                  <span className="formDetalle__input-prefix">$</span>
                  <input
                    type="number"
                    value={form.aofd_ofertacosto ?? ''}
                    className="formDetalle__input formDetalle__input--readonly formDetalle__input--costo"
                    readOnly
                  />
                </div>
              </div>

              <div className="formDetalle__field">
                <label>Precio Artículo</label>
                <div className="formDetalle__input-group">
                  <span className="formDetalle__input-prefix">$</span>
                  <input
                    type="number"
                    value={form.aofd_art_nprecio ?? ''}
                    className="formDetalle__input formDetalle__input--readonly"
                    readOnly
                  />
                </div>
              </div>

              <div className="formDetalle__field">
                <label>Margen Actual</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    value={form.aofd_margenactual ?? ''}
                    className="formDetalle__input formDetalle__input--readonly formDetalle__input--margen"
                    readOnly
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN: CONFIGURACIÓN DE OFERTA */}
          <div className="formDetalle__section formDetalle__section--edit">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">🏷️</span>
              Configuración de Oferta
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--4cols">
              
              <div className="formDetalle__field">
                <label>% Descuento</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    name="aofd_ofertadescto"
                    value={form.aofd_ofertadescto ?? ''}
                    className="formDetalle__input formDetalle__input--descuento"
                    onChange={handleInputChange}
                    step="0.01"
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
                {errors.aofd_ofertadescto && <span className="formDetalle__error">{errors.aofd_ofertadescto}</span>}
              </div>

              <div className="formDetalle__field formDetalle__field--highlight">
                <label>Precio Oferta</label>
                <div className="formDetalle__input-group">
                  <span className="formDetalle__input-prefix">$</span>
                  <input
                    type="number"
                    name="aofd_ofertaprecio"
                    value={form.aofd_ofertaprecio ?? ''}
                    className="formDetalle__input formDetalle__input--precio"
                    onChange={handleInputChange}
                    step="0.01"
                  />
                </div>
                {errors.aofd_ofertaprecio && <span className="formDetalle__error">{errors.aofd_ofertaprecio}</span>}
              </div>

              <div className="formDetalle__field">
                <label>Margen Oferta</label>
                <div className="formDetalle__input-group">
                  <input
                    type="number"
                    value={form.aofd_margen ?? ''}
                    className={`formDetalle__input formDetalle__input--readonly ${
                      Number(form.aofd_margen) >= 0 ? 'formDetalle__input--positive' : 'formDetalle__input--negative'
                    }`}
                    readOnly
                  />
                  <span className="formDetalle__input-suffix">%</span>
                </div>
              </div>

              <div className={`formDetalle__field ${Number(tipooferta) === 0 ? 'formDetalle__field--disabled' : ''}`}>
                <label>Stock Oferta</label>
                <input
                  type="number"
                  name="aofd_ofertastock"
                  value={form.aofd_ofertastock ?? ''}
                  className={`formDetalle__input ${Number(tipooferta) === 0 ? 'formDetalle__input--readonly' : ''}`}
                  onChange={handleInputChange}
                  readOnly={Number(tipooferta) === 0}
                  placeholder={Number(tipooferta) === 0 ? 'N/A' : 'Cantidad'}
                />
                {errors.aofd_ofertastock && <span className="formDetalle__error">{errors.aofd_ofertastock}</span>}
              </div>
            </div>
          </div>

          {/* SECCIÓN: OPCIONES */}
          <div className="formDetalle__section formDetalle__section--options">
            <div className="formDetalle__section-title">
              <span className="formDetalle__section-icon">🔧</span>
              Opciones
            </div>
            <div className="formDetalle__section-content formDetalle__section-content--row">
              <div className="formDetalle__checkboxes">
                <label className="formDetalle__checkbox">
                  <input
                    type="checkbox"
                    checked={form.aofd_show_web === 0}
                    onChange={(e) => setForm({ ...form, aofd_show_web: e.target.checked ? 0 : 1})}
                  />
                  <span className="formDetalle__checkbox-label">🌐 Mostrar en Web</span>
                </label>
                <label className="formDetalle__checkbox">
                  <input
                    type="checkbox"
                    checked={form.aofd_show_app === 0}
                    onChange={(e) => setForm({ ...form, aofd_show_app: e.target.checked ? 0 : 1 })}
                  />
                  <span className="formDetalle__checkbox-label">📱 Mostrar en App</span>
                </label>
              </div>
            </div>
          </div>

          {/* RESUMEN */}
          {form.aofd_art_nprecio && form.aofd_ofertaprecio && (
            <div className="formDetalle__section formDetalle__section--summary">
              <div className="formDetalle__summary">
                <div className="formDetalle__summary-item">
                  <span className="formDetalle__summary-label">Precio Original:</span>
                  <span className="formDetalle__summary-value formDetalle__summary-value--original">
                    ${Number(form.aofd_art_nprecio).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                  </span>
                </div>
                <div className="formDetalle__summary-arrow">→</div>
                <div className="formDetalle__summary-item">
                  <span className="formDetalle__summary-label">Precio Oferta:</span>
                  <span className="formDetalle__summary-value formDetalle__summary-value--oferta">
                    ${Number(form.aofd_ofertaprecio).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                  </span>
                </div>
                <div className="formDetalle__summary-badge">
                  -{Math.abs(Number(form.aofd_ofertadescto || 0)).toFixed(0)}%
                </div>
              </div>
            </div>
          )}

          {/* BOTONES */}
          <div className="formDetalle__actions">
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--primary"
              onClick={handleSendData}
              disabled={isSubmitting}
            >
              {isSubmitting ? '⏳ Guardando...' : '✓ Guardar'}
            </button>
            <button
              type="button"
              className="formDetalle__btn formDetalle__btn--secondary"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              ✕ Cancelar
            </button>
          </div>
        </div>
      </div>

      <ErrorDialog
        isOpen={isErrorDialogOpen}
        onClose={closeErrorDialog}
        message={errorMessage}
        title=""
      />
    </>
  );
};

export default FormDetalle;